
import PlaidLink from '../../components/Plaid/PlaidLink.vue';
import { eventEmitter } from '@/utils/helpers';
import { defineComponent, ref, onMounted, getCurrentInstance, nextTick } from 'vue';
import { useStore } from 'vuex';

export default defineComponent({
    components: {
        PlaidLink
    },
    setup() {
        const store = useStore();
        const instance = getCurrentInstance();
        const toast = instance?.appContext.config.globalProperties.$toast;
        
        const showPlaidLinkContainer = ref(false);

        const onSuccess = (public_token: any) => {
            store.dispatch('authPlaidSubscription', { public_token })
                .then(() => toast?.success('Confirmed'));
        };

        const onLoad = (v: any) => {
            console.log(v);
        };

        onMounted(() => {
            eventEmitter.on('openPlaidLink', async (event: any) => {
                showPlaidLinkContainer.value = false;
                if (!await store.dispatch('startPlaidSubscription')) {
                    throw new Error('Failed to get link');
                }
                nextTick(() => {
                    showPlaidLinkContainer.value = true;
                });
            });
        });

        return {
            store,
            showPlaidLinkContainer,
            onSuccess,
            onLoad
        };
    }
});
